var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('h4',{staticClass:"title md-layout-item md-size-100 text-primary"},[_vm._v(_vm._s(_vm.item.description.topic))]),_c('hr',{staticClass:"text-primary",staticStyle:{"margin-top":"140px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }